import { graphql } from "../gql/gql";

export default graphql(`
  query GetSlates($sport: ProjectionSports!, $range: Range) {
    getSlates(sport: $sport, range: $range) {
      id
      name
    }
  }
`);
